import React from "react";
import { Box } from "@mui/material";
import Locations from "./Locations";

const MemberLocationsCard = () => (
  <Box sx={{ mt: 5 }}>
    <Locations />
  </Box>
);

export default MemberLocationsCard;
